import { useAuth } from 'react-oidc-context';
export function useSignoutRedirect() {
  var auth = useAuth();
  return auth.signoutRedirect;
}